var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"404"}},[_c('BottomBar'),_c('Empty',{attrs:{"icon":true,"icon-class":"anyteach-error2","title":"404","subtitle":"抱歉，找不到您要查看的页面","link":"/courses","link-text":" 查看课程"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }